
export class PostModel {
    PostUid: string = '';
    TempUid: string = '';
    ManufacturerUid: string = '';
    CompanyName: string = '';
    CompanyLogoName: string = '';
    PseudoCompanyLogoName: string = '';
    CompanyShortName: string = '';
    PostDescr: PostLangModel[] = [];
    PostImage: PostMediaModel = new PostMediaModel();
    PostPdf: PostMediaModel = new PostMediaModel();
    constructor(post?: {
        PostUid: string;
        TempUid: string;
        ManufacturerUid: string;
        CompanyName: string;
        CompanyLogoName: string;
        PseudoCompanyLogoName: string;
        CompanyShortName: string;
        PostDescr: PostLangModel[];
        PostImage: PostMediaModel;
        PostPdf: PostMediaModel;
    }) {
        if (post !== undefined) {
            this.PostUid = post.PostUid;
            this.TempUid = post.TempUid;
            this.ManufacturerUid = post.ManufacturerUid;
            this.CompanyName = post.CompanyName;
            this.CompanyLogoName = post.CompanyLogoName;
            this.PseudoCompanyLogoName = post.PseudoCompanyLogoName;
            this.CompanyShortName = post.CompanyShortName;
            this.PostDescr = post.PostDescr;
            this.PostImage = post.PostImage;
            this.PostPdf = post.PostPdf;
        }
    }
}

export class PostMediaModel {
    Url: string = '';
    PseudoName: string = '';
    OriginalName: string = '';
    TempUid: string = '';

    constructor(item?: {
        Url: string;
        PseudoName: string;
        OriginalName: string;
        TempUid: string;
    }) {
        if (item !== undefined) {
            this.Url = item.Url;
            this.PseudoName = item.PseudoName;
            this.OriginalName = item.OriginalName;
            this.TempUid = item.TempUid;
        }
    }
}

export class SkeinPostModel {
    PostUid: string = '';
    ManufacturerUid: string = '';
    CompanyShortName: string = '';
    PseudoImageName: string = '';
    Description: string = '';
    CreatedOn: Date = new Date();
    TotalPosts: number = 0;
    constructor(post?: {
        PostUid: string;
        ManufacturerUid: string;
        CompanyShortName: string;
        PseudoImageName: string;
        Description: string;
        CreatedOn: Date;
        TotalPosts: number;
    }) {
        if (post !== undefined) {
            this.PostUid = post.PostUid;
            this.ManufacturerUid = post.ManufacturerUid;
            this.CompanyShortName = post.CompanyShortName;
            this.PseudoImageName = post.PseudoImageName;
            this.Description = post.Description;
            this.CreatedOn = post.CreatedOn;
            this.TotalPosts = post.TotalPosts;
        }
    }
}

export class PostLangModel {
    PostUid: string = '';
    Description: string = '';
    Language: string = '';
    constructor(data?: Partial<PostLangModel>) {
        if (data) Object.assign(this, data);
    }
}